import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const urn = "admin/users";

const users = axios.create({
  baseURL: queryParams.apiVersion + urn
});

export const adminUsersApi = {
  getSettings(params) {
    return users.get("get_settings", params);
  },
  getUsers(params) {
    return users.post("get_users", params);
  },
  getActions(params) {
    return users.get("/get_actions_list", params);
  },
  getEmails(params) {
    return users.get("/get_user_emails", params);
  },
  getEmailBody(params) {
    return users.get("/get_user_emails_body", params);
  },
  confirm(params) {
    return users.post("/confirm", params);
  },
  sendVerificationCode(params) {
    return users.post("/send_verification_code", params);
  },
  addUser(params) {
    return users.post("", params);
  },
  setAdmin(params) {
    return users.post("set_as_admin", params);
  },
  addAdminUser(params) {
    return users.post("create_admin_user", params);
  },
  updateUser(id, params) {
    return users.put(`/${id}`, params);
  },
  getUserInfo(params) {
    return users.get("/get_users_info", params);
  },
  sendResetPasswordInstructions(params) {
    return users.post("/send_reset_password_instructions", params);
  },
  sendDailyReportEmail(params) {
    return users.post("/send_daily_report", params);
  },
  sendWelcomeEmail(params) {
    return users.post("/send_welcome_email", params);
  },
  sendUsaPtDailyStatSheetEmail(params) {
    return users.post("/send_usa_pt_daily_stat_sheet_email", params);
  },
  sendLocationComparisonDailyEmail(params) {
    return users.post("/send_location_comparison_email", params);
  },
  sendInactiveUsersEmail(params) {
    return users.post("/send_no_activity_users_email", params);
  },
  removeUser(params) {
    return users.delete("/destroy_user", params);
  },
  reactivate(params) {
    return users.post("/reactivate", params);
  },
  duplicateUser(params) {
    return users.post("/duplicate_user", params);
  },
  mirrorUser(params) {
    return users.post("/mirror_user", params);
  },
  resetPassword(params) {
    return users.post("/reset_password", params);
  },
  loginAs(params) {
    return users.post("/login_as", params);
  },
  exportActive(params) {
    return users.post("/export_active", params);
  },
  enableAccount(params) {
    return users.post("/enable_account", params);
  },
  import(params) {
    return users.post("/import", params);
  }
};

export const sendCode = async (type = "sms") => {
  if (process.env.NODE_ENV !== "development") {
    await adminUsersApi.sendVerificationCode({
      type
    });
  }
};

export const menuActions = {
  exportActiveUsers: { type: "request", endpoint: adminUsersApi.exportActive },
  unlockAccount: { type: "request", endpoint: adminUsersApi.enableAccount },
  sendDailyReportEmail: { type: "request", endpoint: adminUsersApi.sendDailyReportEmail },
  usaPtDailyStatSheetEmail: {
    type: "request",
    endpoint: adminUsersApi.sendUsaPtDailyStatSheetEmail
  },
  locationComparisonDailyEmail: {
    type: "request",
    endpoint: adminUsersApi.sendLocationComparisonDailyEmail
  },
  inactiveUsersEmail: { type: "request", endpoint: adminUsersApi.sendInactiveUsersEmail },
  resetPasswordInstructions: {
    type: "request",
    endpoint: adminUsersApi.sendResetPasswordInstructions
  },
  welcomeEmail: { type: "request", endpoint: adminUsersApi.sendWelcomeEmail },
  duplicate: { type: "popup", requiresUser: true },
  mirror: { type: "popup", requiresUser: true },
  loginAs: { type: "popup", requiresUser: true },
  setAdmin: { type: "popup", requiresUser: true },
  addUser: { type: "popup", requiresUser: false },
  addAdminUser: { type: "popup", requiresUser: false },
  bulkUsersCreation: { type: "popup", requiresUser: false }
};
